import * as util from '../util/util'

import * as texto from '../util/texto'

import * as ws_base from '../ws/ws_base'

import CryptoJS from 'crypto-js';

import {buscarImagemUsuario} from './ws_imagem_usuario'


const DOMINIO = "usuarios";



export async function login(tipo, usuario, senha, token, email=null, nome=null, id_remoto=null, url_imagem=null){

	let retorno = await ws_base.post(DOMINIO, "login", {
														"tipo": tipo,
														"usuario": usuario, 
														"chave": util.temConteudo(senha)?CryptoJS.SHA256(senha).toString(CryptoJS.enc.Hex):null, 
														"token_firebase": token,
														"email": email, 
														"nome": nome, 
														"id_remoto": id_remoto, 
														"url_imagem": url_imagem}, 
													false);

    console.log('dados retorno: '+JSON.stringify(retorno));

	if(retorno== null || retorno.status<=0 || !util.temConteudo(retorno.dados))
		return null;

	console.log('dados retorno: '+JSON.stringify(retorno.dados[0]));
	
	return retorno.dados[0];
}


export async function novoUsuario(usuario){

	usuario.senha = CryptoJS.SHA256(usuario.senha).toString(CryptoJS.enc.Hex);
	
	let retorno = await ws_base.post(DOMINIO, "novo", usuario, false);

    console.log('dados retorno: '+JSON.stringify(retorno));

	if(retorno== null)
		return {"id": null, "mensagem": ws_base.MENSAGEM_ERRO_GENERICA};

	if(retorno.status<=0)
		return {"id": null, "mensagem": texto.isNotBlanck(retorno.mensagem)?retorno.mensagem:ws_base.MENSAGEM_ERRO_GENERICA};

	console.log('dados retorno: '+retorno.dados.id);
	
	return {"id": retorno.dados.id, "mensagem":null};
}


export async function buscarUsuario(id){

	return util.primeiroOuNada(await ws_base.get(DOMINIO, "obter", {"id": id}));
}


export async function verificarEmail(id){

	return await ws_base.get(DOMINIO, "confirmar_email", {"id": id});
}


export async function verificarTel(id){

	return await ws_base.get(DOMINIO, "confirmar_tel", {"id": id});
}


export async function enviarCodigoVerificacaoTel(token){

	return await ws_base.get(DOMINIO, "verificar_tel", {"token": token});
}


export async function alterarUsuario(usuario){

	let retorno = await ws_base.post(DOMINIO, "alterar", usuario, false);

    console.log('dados retorno: '+JSON.stringify(retorno));

	if(retorno== null)
		return {"id": null, "mensagem": ws_base.MENSAGEM_ERRO_GENERICA};

	if(retorno.status<=0)
		return {"id": null, "mensagem": texto.isNotBlanck(retorno.mensagem)?retorno.mensagem:ws_base.MENSAGEM_ERRO_GENERICA};

	return {"id": usuario.id, "mensagem":null};
}


export async function buscar_loja(id_usuario, codigo){

	let loja = util.primeiroOuNada(await ws_base.get(DOMINIO, "buscar_loja", {"id_usuario": id_usuario, 
																				"codigo": codigo}));
		
	if(util.temConteudo(loja)){
		
		loja['imagem'] = null;

		let imagem  = await buscarImagemUsuario(loja.id);
   
		if(util.temConteudo(imagem) && util.temConteudo(imagem.imagem))
			loja['imagem'] = imagem.imagem;
	}
	
	return loja;
}


export async function usuario_gestor(id){

	return await ws_base.get(DOMINIO, "gestor", {"id": id});
}


export async function usuario_admin(id){

	return await ws_base.get(DOMINIO, "admin", {"id": id});
}


export async function email_verificado(id){

	return await ws_base.get(DOMINIO, "email_verificado", {"id": id});
}


export async function recuperar_senha(email){

	let retorno = await ws_base.get(DOMINIO, "recuperar_senha", {"email": email}, false);

	if(retorno== null)
		return {"token": null, "mensagem": ws_base.MENSAGEM_ERRO_GENERICA};

	if(retorno.status<=0)
		return {"token": null, "mensagem": texto.isNotBlanck(retorno.mensagem)?retorno.mensagem:ws_base.MENSAGEM_ERRO_GENERICA};

	return {"token": retorno.dados.token, "mensagem":null};
}


export async function buscar_usuario_login_google(token){

	return await ws_base.post("google", "login", {"token": token});
}